<script>
import TableView from '@/components/TableView.vue';
import common from '@/mixins/common.vue';
import { mapActions } from 'vuex';
import DatePicker from '@/components/DatePicker.vue';
import { exportCCHPaymentFile, exportInsureFile, getCurrentDate, getUUId } from '@/pages/utils/tool';
import CaseInsureView from '@/components/CaseInsureView.vue';
import ListEditor from '@/components/ListEditor.vue';
import CaseInsurePrintDialog from '@/components/CaseInsurePrintDialog.vue';
import exportWord from 'export-docx';
import FinanceCreditDialog from '@/components/FinanceCreditDialog.vue';

export default {
  name: 'FinanceInsureList',
  components: { FinanceCreditDialog, ListEditor, CaseInsureView, DatePicker, TableView, CaseInsurePrintDialog},
  mixins: [common],
  data(){
    return {
      items: [],
      loading: false,
      loadingExport: false,
      totalItems: 0,
      pageIndex: 1,
      limit: 25,
      startDate: "",
      endDate: "",
      keyword: '',
      searchKey: '',
      searchValue: '',
      displayId: '',
      insureDialog: {
        visible: false,
        itemDetail: null,
        mode: '',
        confirm: () => {},
        cancel: () => {},
      },
      toolDialog: {
        title: "",
        text: "",
        item: null,
        visible: false,
        confirm: () => {},
        cancel: () => {},
      },
    }
  },
  created() {
    this.setDefaultDate();
    this.loadData();
  },
  computed:{
    getSearchKeys(){
      return [
        { key:'insureId', value: '系統編號'},
        { key:'displayId', value: '案件編號'},
        { key:'insureAgent', value: '對保人員'},

      ]
    },
    columnKeys(){
      return [
        { value: "edit", text: "編輯", sortable: false, required: false , color:'primary', isEvent: true},
        { value: "tools", text: "選單", sortable: false, required: false , color:'success', isEvent: true},
        { value: "copy", text: "複製", sortable: false, required: false , color:'info', isEvent: true},
        { value: "insureId", text: "系統編號", sortable: true, required: false },
        { value: "displayId", text: "案件編號", sortable: true, required: false },
        { value: "name", text: "申請人", sortable: true, required: false },
        { value: "vendorName", text: "經銷", sortable: true, required: false },
        { value: "insureAgent", text: "對保人員", sortable: true, required: false},
        { value: "realInsureAgent", text: "派對人員", sortable: true, required: false},
        { value: "type", text: "對象", sortable: true, required: false},
        { value: "status", text: "核銷狀態", sortable: true, required: false ,isSelect : true
          , options: [{ key: 0, text:'未核銷'}, { key: 1, text:'已核銷'}]},
        { value: "actualGuaranteeCash", text: "實際對保費", sortable: true, required: false},
        { value: "insureDate", text: "對保日期", sortable: true, required: false},
        { value: "createdDate", text: "建立時間", sortable: true, required: false},
        { value: "delete", text: "刪除", sortable: false, required: false , isEvent: true}
      ];
    }
  },
  methods:{
    ...mapActions(['getAdminInsureInfoList', 'writeOffInsureInfo', 'deleteInsureInfo', 'createInsureInfo','getExportInsureInfoList']),
    setDefaultDate() {
      let todayDate = new Date();
      todayDate.setMonth(todayDate.getMonth() - 1);
      let currentDate = todayDate.toISOString().substr(0, 10);
      const [thisYear, thisMonth, thisDay] = currentDate.split("-");
      this.startDate = `${thisYear}-${thisMonth}-01`;

      let futureDate = new Date();
      // 将当前月份加1，下移到下个月
      futureDate.setMonth(futureDate.getMonth() + 1);
      // 再获取天数即取上个月的最后一天的天数
      futureDate.setDate(0);
      let days = futureDate.getDate();

      let endDate = futureDate.toISOString().substr(0, 10);
      const [futureYear, futureMonth, futureDay] = endDate.split("-");

      this.endDate = `${futureYear}-${futureMonth}-${days}`;
    },
    async cellEvent(prop){
      console.log(`cell ${JSON.stringify(prop)}`);
      if (prop.key === 'edit'){
        this.insureDialog.mode = 'list';
        this.insureDialog.itemDetail = prop.item;
        this.insureDialog.visible = true;
        this.insureDialog.confirm = ()=> {
          this.insureDialog.visible = false;
          this.loadData();
        }
      }
      if (prop.key === 'delete'){
        await this.deleteInsureInfo({
          insureId: prop.item.insureId,
        });
        await this.loadData();
      }
      if (prop.key === 'tools'){
        this.toolDialog.item = prop.item;
        this.toolDialog.visible = true;
      }
      if (prop.key === 'copy'){
        await this.copyEvent(prop.item);
      }
      if (prop.key === 'export'){
        exportWord('https://rcdesign.io/temp/template_agent.docx', { name: prop.item.name } , `${prop.item.name}_(自印檔)委任代辦契約書.docx`)
      }
    },
    reset(){
      this.keyword = '';
    },
    async loadData(){
      try {
        let searchQuery = [];
        if (this.searchKey && this.keyword) {
          searchQuery.push({
            key: `${this.searchKey}`,
            value: `${this.keyword}`,
          });
        }

        this.loading = true;
        const res = await this.getAdminInsureInfoList({
          // agentId: (this.isAdmin || this.isTimeAdmin) ? "" : this.getUserInfo.agentId,
          startDate: `${this.startDate} 00:00:00`,
          endDate: `${this.endDate} 23:59:59`,
          pageIndex: this.pageIndex,
          limit: this.limit,
          searchQuery: searchQuery });
        const result = res.data;
        if (result && result.statusCode === 0){
          this.items = result.data.list;
          this.totalItems = result.data.header.totalCount;
        }
      } catch (e) {
        console.log(`loadData error` , e);
      } finally {
        this.loading = false;
      }
    },
    async copyEvent(item){
      try {
        this.loading = true;
        item.insureId = getUUId();
        delete item.name;
        delete item.vendorName;
        const res = await this.createInsureInfo(item);
        const result = res.data;
        console.log(`copy InsureInfo ${JSON.stringify(result)}`);
        if (result && result.statusCode === 0){
          await this.loadData();
        } else {
          this.showMessageDialog(`複製失敗`);
        }
      } catch (e) {
        console.log(`copy error ` , e);
        this.showMessageDialog(`複製失敗`);
      } finally {
        this.loading = false;
      }
    },
    searchEvent(){
      this.loadData();
    },
    async exportData(){
      const cols = [
        {
          value: "insureId",
          text: "系統編號",
        },
        {
          value: "displayId",
          text: "案件編號",
        },
        {
          value: "name",
          text: "申請人",
        },
        {
          value: "vendorName",
          text: "經銷",
        },
        {
          value: "insureAgent",
          text: "對保人員",
        },
        {
          value: "realInsureAgent",
          text: "派對人員",
        },
        {
          value: "type",
          text: "對象",
        },
        {
          value: "otherName",
          text: "其他費用名稱",
        },
        {
          value: "otherPrice",
          text: "其他費用金額",
        },
        {
          value: "insureAmount",
          text: "本票金額",
        },
        {
          value: "guaranteeCash",
          text: "對保收現",
        },
        {
          value: "exposuresCash",
          text: "風險承擔費",
        },
        {
          value: "engravedSeal",
          text: "代刻印章",
        },
        {
          value: "postage",
          text: "郵資",
        },
        {
          value: "emptyFare",
          text: "空趟費",
        },
        {
          value: "actualGuaranteeCash",
          text: "實際對保費",
        },
        {
          value: "insureDate",
          text: "對保日期",
        },
        {
          value: "memo",
          text: "備註",
        },
      ];
      let list = [];
      try {
        this.loadingExport = true;
        const res = await this.getExportInsureInfoList({
          // agentId: (this.isAdmin || this.isTimeAdmin) ? "" : this.getUserInfo.agentId,
          startDate: `${this.startDate} 00:00:00`,
          endDate: `${this.endDate} 23:59:59`,
          pageIndex: this.pageIndex,
          limit: 1000,
          searchQuery: [] });
        const result = res.data;
        if (result && result.statusCode === 0){
          list = result.data.list;
          exportInsureFile(`對保費匯出_${getCurrentDate()}`, cols, list);
        }
      } catch (e) {
        console.log(`exportData error` , e);
      } finally {
        this.loadingExport = false;
      }
    },
    async writeOffEvent(){
      try {
        const res = await this.writeOffInsureInfo({
          insureId: this.displayId.trim(),
          status: 1,
        });
        const result = res.data;
        if (result && result.statusCode === 0){
          await this.loadData();
        } else {
          this.showMessageDialog(`核銷失敗: ${result.message}`);
        }
      } catch (e){
        console.log(`writeOffInsureInfo error` , e);
        this.showMessageDialog('核銷失敗');
      }
    },
    add(){
      this.insureDialog.mode = 'searchAdd';
      this.insureDialog.visible = true;
      this.insureDialog.confirm = ()=> {
        this.insureDialog.visible = false;
        this.loadData();
      }
    },
    closeInsureDialog(){
      this.insureDialog.visible = false;
    },
    changePage(page) {
      this.pageIndex = page.page;
      this.limit = page.rowsPerPage;
      this.loadData();
    },
    toolEvent(index){

    }
  },

};
</script>

<template>
<div>
  <v-container fluid>
    <v-layout>
      <v-flex xs12 md6>
        <v-btn color="primary" dark text @click="add()" >新增</v-btn>
      </v-flex>
    </v-layout>
    <v-layout  mt-2 >
      <v-flex xs5 sm5 md5>
        <date-picker :date.sync="startDate" />
      </v-flex>
      <v-flex xs5 sm5 md5>
        <date-picker :date.sync="endDate" />
      </v-flex>
    </v-layout>
    <v-layout mt-2 >
      <v-flex md2 xs8 >
        <v-select :items="getSearchKeys"
                  item-text="value"
                  item-value="key"
                  v-model="searchKey"
                  label="查詢條件"
        ></v-select>
      </v-flex>
      <v-flex ml-2 md4 xs8>
        <v-text-field v-model="keyword" :label="`搜尋客戶`" :placeholder="'搜尋案編'"
                      @keyup.enter="searchEvent"></v-text-field>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex md6 xs6>
        <v-btn color="primary" @click="searchEvent">搜尋</v-btn>
        <v-btn color="warning" @click="reset">重置</v-btn>
        <v-btn color="success" :loading="loadingExport" @click="exportData">匯出</v-btn>
      </v-flex>
    </v-layout>
    <v-layout mt-2 >
      <v-flex md2 xs6>
        <v-text-field v-model="displayId" :label="`案件編號`" :placeholder="'案件編號'"></v-text-field>
      </v-flex>
      <v-flex md2 xs6>
        <v-btn color="primary" @click="writeOffEvent">核銷</v-btn>
      </v-flex>
    </v-layout>

    <v-layout>
      <table-view :columnKeys="columnKeys"
                  :items="items"
                  :loading="loading"
                  :total-items="totalItems"
                  @changePage="changePage"
                  @cellEvent="cellEvent"
                  @handleLoadData="reset">
      </table-view>
    </v-layout>

    <!--案件對保資料-->
    <v-dialog
      v-model="insureDialog.visible"
      persistent
      :width="isMobile ? '90%' : '60%'">
      <v-card>
        <v-card-title>
          <h3>案件對保資料</h3>
        </v-card-title>
        <v-card-text>
          <case-insure-view
            :item-detail="insureDialog.itemDetail"
            :mode="insureDialog.mode"
            :show="insureDialog.visible"
            @saveEvent="insureDialog.confirm"
            @cancelEvent="insureDialog.cancel"
          ></case-insure-view>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" dark text @click="closeInsureDialog" >關閉</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <CaseInsurePrintDialog
      :item="toolDialog.item"
      :visible="toolDialog.visible"
      :platform="0"
      @showEvent="toolEvent"
      @closeEvent="toolDialog.visible = false"
      @confirmEvent="toolDialog.visible = false"
    />
  </v-container>


</div>
</template>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/web/FinanceInsureList.vue